import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './useAuth';

export const useUserRole = () => {
  const { user, loading: authLoading } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Wait for auth to finish resolving before deciding admin status
    if (authLoading) {
      console.log('useUserRole: Auth still loading, delaying role check');
      setLoading(true);
      return;
    }

    const checkUserRole = async () => {
      console.log('useUserRole: Checking user role for:', user?.id);

      if (!user) {
        console.log('useUserRole: No user found after auth, setting isAdmin to false');
        setIsAdmin(false);
        setLoading(false);
        return;
      }

      try {
        const { data, error } = await supabase.rpc('has_role', {
          _user_id: user.id,
          _role: 'admin',
        });

        console.log('useUserRole: RPC response:', { data, error });

        if (error) {
          console.error('Error checking user role:', error);
          setIsAdmin(false);
        } else {
          const adminStatus = data || false;
          console.log('useUserRole: Setting isAdmin to:', adminStatus);
          setIsAdmin(adminStatus);
        }
      } catch (error) {
        console.error('Error checking user role:', error);
        setIsAdmin(false);
      }

      setLoading(false);
    };

    checkUserRole();
  }, [user, authLoading]);

  return { isAdmin, loading };
};